import { IconManifest } from 'app/agriculture/icons/types';
import { MapIconOptions } from './types';
import { taskIcon } from 'app/agriculture/icons/assets';
import { errorColourMain, primaryColourMain, secondaryColourMain } from 'app/agriculture/material';
import { TaskPriority } from 'app/agriculture/queries/tasks/types/TaskPriority';

const overdueAssignedToYou: MapIconOptions = {
    iconColor: '#fff',
    color: errorColourMain,
    shouldIncludeBorder: true,
    borderColor: '#fff',
    billboardType: 'pin',
};

const normalPriorityAssignedToYou: MapIconOptions = {
    iconColor: '#fff',
    color: primaryColourMain,
    shouldIncludeBorder: true,
    borderColor: '#fff',
    billboardType: 'pin',
};

const highPriorityAssignedToYou: MapIconOptions = {
    iconColor: '#fff',
    color: secondaryColourMain,
    shouldIncludeBorder: true,
    borderColor: '#fff',
    billboardType: 'pin',
};

const overdueAssignedToOther: MapIconOptions = {
    iconColor: errorColourMain,
    color: '#fee3e7',
    shouldIncludeBorder: false,
    billboardType: 'pin',
};

const normalPriorityAssignedToOther: MapIconOptions = {
    iconColor: primaryColourMain,
    color: '#fff',
    shouldIncludeBorder: false,
    billboardType: 'pin',
};

const highPriorityAssignedToOther: MapIconOptions = {
    iconColor: secondaryColourMain,
    color: '#ffe8dd',
    shouldIncludeBorder: false,
    billboardType: 'pin',
};

export interface TaskOptions {
    priority: TaskPriority;
    overdue: boolean;
    assignedToYou: boolean;
}

function getTaskIconOptions(taskOptions: TaskOptions) {
    const { priority, overdue, assignedToYou } = taskOptions;
    if (overdue) {
        return assignedToYou ? overdueAssignedToYou : overdueAssignedToOther;
    }
    if (priority == 'High') {
        return assignedToYou ? highPriorityAssignedToYou : highPriorityAssignedToOther;
    }
    return assignedToYou ? normalPriorityAssignedToYou : normalPriorityAssignedToOther;
}

export function getTaskIconConfig(taskOptions: TaskOptions): {
    icon: IconManifest;
    options: MapIconOptions;
} {
    return {
        icon: taskIcon,
        options: getTaskIconOptions(taskOptions),
    };
}
